/** Canonical UUID matcher (8-4-4-4-12 hex, case-insensitive). */
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The nil UUID. Used as a syntactically-valid placeholder for a required
 * `UUID!` variable when the associated field is skipped (a malformed value
 * would otherwise fail GraphQL variable coercion and error the whole query).
 */
export const NIL_UUID = "00000000-0000-0000-0000-000000000000";

/** Returns true when the value is a canonically-formatted UUID. */
export function isValidUuid(value: string | undefined | null): boolean {
  return !!value && UUID_PATTERN.test(value);
}
